import React, { useEffect, useState } from "react";
import { auth, db } from "../firebaseConfig";
import { doc, setDoc, getDoc, collection, getDocs } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import "../styles/ProfilePage.css";
import { signOut } from "firebase/auth";

const ProfilePage = () => {
  const user = auth.currentUser;
  const [username, setUsername] = useState(user?.displayName || "");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [points, setPoints] = useState(0);
  const [orders, setOrders] = useState([]);
  const [saving, setSaving] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const loadProfile = async () => {
      if (!user) return;
      const ref = doc(db, "users", user.uid);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setPhone(data.phone || "");
        setAddress(data.address || "");
        setPoints(data.points || 0);
      }

      const ordersRef = collection(db, "users", user.uid, "orders");
      const ordersSnap = await getDocs(ordersRef);
      const ordersList = ordersSnap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setOrders(ordersList);
    };
    loadProfile();
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!phone || !address) {
      alert("Numer telefonu i adres są wymagane.");
      return;
    }
    setSaving(true);
    await setDoc(doc(db, "users", user.uid), {
      username,
      phone,
      address,
      points,
    });
    setSaving(false);
    alert("Dane zostały zapisane.");
  };

  if (!user) {
    return <p className="profile-page">Musisz być zalogowany, aby zobaczyć profil.</p>;
  }
const handleLogout = async () => {
  try {
    await signOut(auth);
    navigate("/"); // Or navigate to login page
  } catch (error) {
    console.error("Sign-out error:", error);
    alert("Wystąpił błąd podczas wylogowania.");
  }
};

  return (
    <div className="profile-page two-column">
      <div className="profile-left">
        <div className="profile-card">
          <button
  type="button"
  className="logout-button"
  onClick={handleLogout}
  style={{ marginTop: "1rem", background: "#eee", color: "#333" }}
>
  Wyloguj się
</button>

          <h2>Twój profil</h2>
          <p><strong>Imię i nazwisko:</strong> {username}</p>
          <form onSubmit={handleSubmit}>
            <label>
              Numer telefonu
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                required
              />
            </label>
            <label>
              Adres dostawy
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                required
              />
            </label>
            <button type="submit" disabled={saving}>
              {saving ? "Zapisywanie..." : "Zapisz zmiany"}
            </button>
          </form>
        </div>
      </div>
      <div className="profile-right">
        <div className="points">
          <h3>Twoje punkty lojalnościowe</h3>
          <p><strong>{points}</strong> punktów</p>
        </div>
        <div className="order-history">
          <h3>Historia zamówień</h3>
          {orders.length === 0 ? (
            <p>Brak zamówień.</p>
          ) : (
            <ul>
              {orders.map((order) => (
                <li key={order.id}>
                  <strong>{order.date || "Data nieznana"}</strong> – {order.items?.length || 0} produktów – {order.total || 0} PLN
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
